import { Component, OnInit } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-data-files',
  templateUrl: './data-files.component.html',
  styleUrls: ['./data-files.component.css']
})
export class DataFilesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
